import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { AuthService } from './services/auth.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { HeaderComponent } from './component/children/header/header.component';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet,HeaderComponent,ToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'Time Tracking -' + environment.ENV;
  isBrowser: any;
  
  constructor(private readonly authService : AuthService,private readonly router : Router,
    @Inject(DOCUMENT) private readonly dom: Document,
    @Inject(PLATFORM_ID) private readonly platformId: Object) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      let location = window.location.search;
      let urlSearchParams = new URLSearchParams(location);
      let params = Object.fromEntries(urlSearchParams?.entries()); 
      if(params['access_token'] != undefined){
        this.authService.login(params['access_token'],params['id_token'],params['refresh_token']);
        this.navigate('')
      }else if(window.location.href.includes('localhost')){
        /* This Section Is for Local machine hosting */
        const token = sessionStorage.getItem('access_token')
        const idToken = sessionStorage.getItem('id_token')
        if(null != token && null != idToken){
          this.authService.login(token,idToken);
        }else{
          alert("**** LOCAL DEVELOPMENT *****\n* Please Add Access Token  *\n* to Session to start your *\n* local development server *\n****************************");
          console.info("%c**** LOCAL DEVELOPMENT *****\n* Please Add Access Token  *\n* to Session to start your *\n* local development server *\n****************************","color:red;")
        }
      }
      
    }

  }

  navigate(route : any){
    this.router.navigateByUrl(route)
  }
}
